import { Home, Calendar, MessageCircle, User } from "lucide-react";
import { BottomTabBar as SharedBottomTabBar, type TabDefinition } from "@shared/components/BottomTabBar";

const TABS: TabDefinition[] = [
  { to: "/", label: "Home", icon: Home },
  { to: "/schedule", label: "Schedule", icon: Calendar, tourId: "tab-schedule" },
  { to: "/messages", label: "Messages", icon: MessageCircle, showUnreadBadge: true },
  { to: "/me", label: "Profile", icon: User },
];

type Props = {
  unreadCount?: number;
};

export function BottomTabBar({ unreadCount = 0 }: Props) {
  return <SharedBottomTabBar tabs={TABS} unreadCount={unreadCount} />;
}
